import React from "react";
import { ReportName } from "types/gql-types";
import { ReportTable } from "./report-table";

export const ApplicationEthnicity: React.FC = () => (
  <ReportTable reportName={ReportName.INTEREST_ETHNICITY} includeTitle />
);
